import styled from "styled-components"; 

export const ContaierPublicidad = styled.div`
    width: 459px;
    height: 404px;
    

    @media (max-width: 700px){
        width: 359px;
        height: 304px;
    }

    button {
        width: 160px;
        height: 40px;
        border-radius: 9px;
        background-color: var(--color-primary);
        color: var(--color-white);
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 10px;
        font-size: 18px;
        margin: auto;
    }
`;

export const PublicidadTop = styled.div`
    width: 100%;
    height: 65px;
    background: var(--color-secondary-gradient);
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    display: flex; 
    justify-content: center; 
    align-items: center; 
    color: var(--color-white);
    font-weight: 700;
    text-align: center;
     
`; 

export const PublicidadBody = styled.div`
    height: 70%;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    display: flex; 
    justify-content: center; 
    align-items: center; 
    font-weight: 500; 
    text-align: center;
`; 